var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "H46yBQ",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{
    trigger: {
      product_page_text: "Notify Me",
      product_page_class: "Button Button--full Button--primary",
      product_page_text_align: "center",
      product_page_margin: "2px",
      replace_anchor: false
    },
    modal: {
    headline: "{product_name}",
    body_content: "drop your email to claim early access when it becomes available",
    email_field_label: "Email",
    button_label: "NOTIFY WHEN AVAILABLE",
    subscription_success_label: "We'll let you know when it's available",
    footer_content: '',
    additional_styles: "@import url('https://fonts.googleapis.com/css2?family=Red+Hat+Display');",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#000000",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500"
    }
  });